import React, { useEffect } from "react";

import * as C from "./Bag.styles";

import BagIcon from "../../assets/icons/BagIcon.svg";
import BinIcon from "../../assets/icons/BinIcon.svg";

const Bag = ({ setOpenFinalForm, currentOrder, setCurrentOrder, quantidade, isOpen, onClose }) => {
    
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }
        return () => {
            document.body.style.overflow = "";
        };
    }, [isOpen]);

    const totalOrder = () => {
        const itemsTotal = Array.isArray(currentOrder.items) ?
            currentOrder.items.reduce((total, pizza) => {
                if (pizza.tipo && pizza.tipo === "combo") {
                    return total + pizza.price;
                }
                const extrasTotal = pizza.extras.reduce((sum, extra) => sum + extra.valor, 0);
                return total + pizza.price + extrasTotal;
            }, 0) : 0;

        const refrisTotal = Array.isArray(currentOrder.refris) ?
            currentOrder.refris.reduce((refriTotal, refri) => refriTotal + refri.price * refri.quantity, 0) : 0;

        return itemsTotal + refrisTotal;
    };

    const handleRemoveItem = (index) => {
        const updatedItems = currentOrder.items.filter((_, i) => i !== index);

        setCurrentOrder((prevState) => ({
            ...prevState,
            items: updatedItems,
        }));
    };

    const handleRemoveRefri = (refriCurent) => {
        const updatedRefris = currentOrder.refris.map((refri) => {
            if (refri.name === refriCurent.name) {
                if (refri.quantity > 1) {
                    return { ...refri, quantity: refri.quantity - 1 };
                }
                return null;
            }
            return refri;
        })
            .filter((refri) => refri !== null);

        setCurrentOrder((prev) => ({
            ...prev,
            refris: updatedRefris,
        }));
    };

    const finishedOrder = () => {
        if (currentOrder.items.length > 0) {
            setOpenFinalForm(true);
            onClose();
            return;
        } else {
            return;
        }
    }

    return (
        isOpen ? (
            <C.Background isOpen={isOpen} >
                <C.BagPopupContainer>
                    <C.BagHeader>
                        <span>Seu pedido atual</span>
                        <button onClick={onClose} >x</button>
                    </C.BagHeader>
                    <C.InformationMessage>Valor total do pedido: R${totalOrder()},00</C.InformationMessage>
                    <C.BagItems>
                        {currentOrder.refris.length > 0 && currentOrder.refris.map((item, index) => (
                            <C.BagItem key={index}>
                                <C.BagItemTitle>{item.name} (R$ {item.price},00)</C.BagItemTitle>
                                <span><C.BagItemTitle>Valor: </C.BagItemTitle>R$ {item.price * item.quantity},00</span>
                                <span><C.BagItemTitle>Quantidade: </C.BagItemTitle>{item.quantity}</span>
                                <div onClick={() => handleRemoveRefri(item)}>
                                    <img src={BinIcon} alt="Ícone de lixeira" />
                                    {/* <span onClick={() => handleRemoveRefri(item)}>Remover 1</span> */}
                                </div>
                            </C.BagItem>
                        ))}

                        {currentOrder.items.length > 0 && currentOrder.items.map((item, index) => (
                            <C.BagItem key={index}>
                                {/* Verificação para exibir dados do combo */}
                                {item.tipo && item.tipo === "combo" ? (
                                    <>
                                        <C.BagItemTitle>Combo (R$ {item.price},00)</C.BagItemTitle>
                                        <span><C.BagItemTitle>- Pizza G: </C.BagItemTitle>{item.pizza.pizza1G || "Não selecionada"}</span>
                                        {item.pizza.pizza2G!== "" && <span><C.BagItemTitle>- Pizza G: </C.BagItemTitle>{item.pizza.pizza2G || "Não selecionada"}</span>}
                                        <span><C.BagItemTitle>- Pizza P: </C.BagItemTitle>{item.pizza.pizza1P || "Não selecionada"}</span>
                                        <span><C.BagItemTitle>- Observações: </C.BagItemTitle>{item.observations || "Nenhuma"}</span>
                                        <span><C.BagItemTitle>- Valor total do item:</C.BagItemTitle> R${item.price}</span>
                                    </>
                                ) : (
                                    <>
                                        {/* Exibição de itens individuais */}
                                        <span>
                                            <C.BagItemTitle>
                                                {item.portion === "Meia"
                                                    ? `Metade ${item.pizza} e Metade ${item.additionalPizza}`
                                                    : `${item.pizza} `}
                                                (R$ {item.price},00)
                                            </C.BagItemTitle>
                                        </span>
                                        <span>
                                            <C.BagItemTitle>Borda: </C.BagItemTitle> {item.pizzaBorder || "Nenhuma"}
                                        </span>
                                        <span>
                                            <C.BagItemTitle>Adicionais: </C.BagItemTitle>
                                            {item.extras.length > 0
                                                ? item.extras.map((extra) => (
                                                    <p key={extra.nome}>- {extra.nome} (R${extra.valor},00)</p>
                                                ))
                                                : "Nenhum"}
                                        </span>
                                        <span>
                                            <C.BagItemTitle>Observações: </C.BagItemTitle> {item.observations || "Nenhuma"}
                                        </span>
                                        <span>
                                            <C.BagItemTitle>Valor total do item: </C.BagItemTitle>
                                            R${item.price +
                                                (item.extras.length > 0
                                                    ? item.extras.reduce((total, extra) => total + extra.valor, 0)
                                                    : 0)}
                                        </span>
                                    </>
                                )}
                                {/* Opção para remover item */}
                                <div onClick={() => handleRemoveItem(index)}>
                                    <img src={BinIcon} alt="Ícone de lixeira" />
                                    {/* <span onClick={() => handleRemoveItem(index)}>Remover</span> */}
                                </div>
                            </C.BagItem>
                        ))}
                    </C.BagItems>

                    <C.InformationMessage>Valor sujeito a alteração de acordo com a taxa de entrega do estabelecimento. Confirme com um atendente após o envio do pedido.</C.InformationMessage>
                    <C.BagButtons>
                        <button onClick={onClose}>Voltar</button>
                        {currentOrder.items.length > 0 && <button onClick={finishedOrder}>Finalizar</button>}
                    </C.BagButtons>
                </C.BagPopupContainer>
            </C.Background>
        ) : (
            <C.BagContainer onClick={onClose}>
                <div>{quantidade}</div>
                <img src={BagIcon} alt="Ícone da sacola" />
                <span>Sacola</span>
            </C.BagContainer>
        )
    );
};

export default Bag;